import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import upliftPrepaidOrders from "../../../assets/img/features/uplift-prepaid-orders.png";

export default function UpliftPrepaidOrders() {
  return (
    <Box
      sx={{
        width: "100%",
        padding:  {xs:"2rem 0", md:"10rem 0"},
        // backgroundColor: 'primary.dark',
        background: "linear-gradient(0deg, rgba(244, 249, 255, 0) 0%, #F4F9FF 100%)",
      }}
    >
      <Box
        sx={{
          height: "inherit",
          width: "inherit",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-evenly",
          alignItems: "center"
        }}
      >
        <Box sx={{ width: { sx: "90vw", md: "40vw", padding: "2rem" } }}>
          <Typography variant="h3" gutterBottom fontWeight={800}>
            UPLIFT YOUR PREPAID ORDERS UPTO 50%+
          </Typography>
          <Typography variant="h5" gutterBottom fontWeight={300} fontSize="1.2rem">
            Make pre-paid more lucrative for your customers by offering UPI discounts. Set-up one click UPI
            payments. Show any Up-Sell message to  your customers.
          </Typography>
        </Box>
        <Box>
          <img src={upliftPrepaidOrders} alt="loading..." width={350} />
        </Box>
      </Box>
    </Box>
  );
}
